import React, { useEffect } from "react";
import "./App.css";
import Header from "./Header";
import Home from "./Home";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Checkout from "./Checkout";
import Login from "./Login";
import Payment from "./Payment";
import Orders from "./Orders";
import SignUp from "./SignUp";
import Footer from "./Footer";
import LegalPage from "./LegalPage";
import { termsContent, privacyContent, returnsContent } from "./legalContent";
import { auth } from "./firebase";
import { useStateValue } from "./StateProvider";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

const stripePromise = loadStripe(
 "pk_test_51OPnXfCtmH0NLR6yUWaDFt6BcsLTsV3sHEpgPHwaOESz0xEy9ah0MSwXVOqQ06GC5sXbn7pkdfWLmPWvfvBbdlyc009t33ehWU"
);

const saveBasketToLocal = (userId, basket) => {
  localStorage.setItem(`basket_${userId}`, JSON.stringify(basket));
};

const loadBasketFromLocal = (userId) => {
  return JSON.parse(localStorage.getItem(`basket_${userId}`)) || [];
};

function App() {
  const [{ user }, dispatch] = useStateValue();

  useEffect(() => {
    auth.onAuthStateChanged((authUser) => {
      if (authUser) {
        dispatch({
          type: "SET_USER",
          user: authUser,
        });
  
        const userBasket = loadBasketFromLocal(authUser.uid);
        dispatch({
          type: 'SET_BASKET',
          basket: userBasket,
        });
      } else {
        dispatch({
          type: "SET_USER",
          user: null,
        });
        dispatch({
          type: 'EMPTY_BASKET',
        });
      }
    });
  }, [dispatch]);
  
  return (
    <Router>
      <div className="app">
        <Switch>
          <Route path="/orders">
            <Header />
            <Orders />
            <Footer />
          </Route>

          <Route path="/signup">
            <SignUp />
          </Route>

          <Route path="/login">
            <Login />
          </Route>

          <Route path="/checkout">
            <Header />
            <Checkout />
            <Footer />
          </Route>

          <Route path="/payment">
            <Header />
            <Elements stripe={stripePromise}>
              <Payment />
            </Elements>
            <Footer />
          </Route>

          {/* Legal Pages */}
          <Route path="/terms">
            <Header />
            <LegalPage content={termsContent} />
            <Footer />
          </Route>
          <Route path="/privacy">
            <Header />
            <LegalPage content={privacyContent} />
            <Footer />
          </Route>
          <Route path="/returns">
            <Header />
            <LegalPage content={returnsContent} />
            <Footer />
          </Route>

          {/* Fallback Home Route */}
          <Route path="/">
            {user ? <Header /> : null}
            {user ? <Home /> : <Login />}
            {user ? <Footer /> : null}
          </Route>

        </Switch>
      </div>
    </Router>
  );
}

export default App;
